var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-12 max-w-full"},[_c('h1',{staticClass:"mb-2 text-3xl text-gray-800 dark:text-gray-500"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bg-white dark:bg-gray-900 p-6 rounded border-gray-300 dark:border-gray-900 border"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }